import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/change-prices`, {params})
    },
    create(params) {
        return Vue.axios.post(`/change-prices/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/change-prices/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/change-prices/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/change-prices/${id}`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
